import { render } from "./OTPSingleInput.vue?vue&type=template&id=70b7134c&scoped=true"
import script from "./OTPSingleInput.vue?vue&type=script&lang=js"
export * from "./OTPSingleInput.vue?vue&type=script&lang=js"

import "./OTPSingleInput.vue?vue&type=style&index=0&id=70b7134c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b7134c"]])

export default __exports__